











import { translate } from "@/filters";
import Vue from "vue";

export default Vue.extend({
	name: "LoadMoreButton",
	props: {
		id: {
			type: String,
			default: ""
		},
		loadMoreResultsLabel: {
			type: String,
			default: "button.loadMoreResults"
		},
		remainingToLoad: {
			type: Number,
			required: true
		}
	},
	computed: {
		loadMoreText() {
			return `${translate(this.loadMoreResultsLabel)} (${this.remainingToLoad})`;
		}
	}
});
